
import { Calendar } from '@fullcalendar/core';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import multiMonthPlugin from '@fullcalendar/multimonth'
import iCalendarPlugin from '@fullcalendar/icalendar'
import googleCalendarPlugin from '@fullcalendar/google-calendar'
export default {
  name: "HomePage",
  components: {
    FullCalendar
  },
  data() {
    return {
      calendarOptions: {
        plugins: [googleCalendarPlugin, dayGridPlugin],
        initialView: 'dayGridMonth',
        views: {
          multiMonthFourMonth: {
            type: 'multiMonth',
            duration: { months: 4 }
          }
        },
        googleCalendarApiKey: 'AIzaSyDV5E2i7rekViQrJ7LTKRfpwX6GEcz0Gic',
        events: {
          googleCalendarId: '323f27a39d935c3649d700508fd0c99f335a4ba700538dfb641aef9d332afb4e@group.calendar.google.com'
        }
      }
    }
  },
  methods: {
    handleDateClick: function (arg) {
      alert('date click! ' + arg.dateStr)
    }
  }
}
